import {
  fetchCustomersByResellerId,
  uploadVirtualBackgroundImage,
} from 'lib/api';
import { Dropdown, LoadingIndicator, PrimaryButton } from 'lib/components';
import { DocumentHead } from 'lib/components/DocumentHead';
import { PageTemplate } from 'lib/components/page/PageTemplate';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useAuth } from 'lib/context';
import React from 'react';
import { MdImage } from 'react-icons/md';
import { useHistory } from 'react-router';
import styled from 'styled-components/macro';

const Container = styled.div`
display: flex;
flex-direction: column;
box-sizing: border-box;
width:100%;
padding: 15px;
height: 100vh;
align-items: center;
justify-content: center;
.dropdown {
    width: 250px;
}

h3{
  
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #324058;
    padding: 0;
    margin: 0 0 10px 0;
`;

const FileInputHandler = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  height: 40px;
  width: 250px;
  border-radius: 4px;
  border: solid 1px #d0d3d9;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: #272a32;
  box-sizing: border-box;
  margin: 20px auto 0 auto;
  word-break: break-all;
  height: fit-content;
  &:focus {
    outline: 0;
  }
  svg {
    &:hover {
      cursor: pointer;
    }
  }
`;

export const VirtualBackgroundUploader = () => {
  const [imageSource, setImageSource] = React.useState('');
  const [imageFile, setImageFile] = React.useState<File>();
  const [customers, setCustomers] = React.useState([]);
  const [selectedCustomer, setSelectedCustomer] = React.useState<any>(
    customers[0] || {}
  );
  const [loading, setLoading] = React.useState(true);

  const { userData } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    const allowedResellerId = 308; // Vidis Reseller ID.
    if (parseInt(userData.resellerId) !== allowedResellerId) {
      history.push('/home');
      setLoading(false);
      return;
    }

    fetchCustomersByResellerId(parseInt(userData.customerId))
      .then(data => {
        if (!data || !data.length) {
          setLoading(false);
          errorToast({ title: 'No Customers' });
          return;
        }

        const options = data.map((item: any) => {
          return {
            value: item.customerId,
            label: item.firstName + ' ' + item.lastName,
          };
        });

        setCustomers(options);
        setSelectedCustomer(options[0]);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        errorToast({ title: 'Something went wrong.' });
      });
  }, []);

  let fileRef = React.createRef<HTMLInputElement>();

  const handleSelectedFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const target = e.target as HTMLInputElement;
    if (target && target.files && target.files[0]) {
      let orgFile: File = target.files[0];
      const isValidType = /.*\.(jpeg|jpg)/i.test(orgFile.name);

      const allowedSize = 1;
      const fileSize = orgFile.size / 1024 / 1024;
      if (fileSize > allowedSize) {
        errorToast({ title: 'File Size should be less than 1MB.' });
        return;
      }

      if (isValidType) {
        let filename = orgFile.name.split('.');
        setImageSource(filename[0]);
        let newFile = new File([orgFile], orgFile.name, {
          type: orgFile.type,
          lastModified: orgFile.lastModified,
        });
        setImageFile(newFile);
        setImageSource(URL.createObjectURL(newFile));
      } else {
        // setError('Invalid format.');
        errorToast({
          title: 'Invalid format. Only images in jpeg formats allowed.',
        });
      }
    } else {
      errorToast({ title: 'Invalid file.' });
    }
  };

  const getUploaderComponent = () => {
    if (loading) {
      return <LoadingIndicator isLoading={loading} text={'Loading...'} />;
    }

    return (
      <Container>
        <h2>Virtual Background Uploader</h2>
        <br />
        <br />
        <h3>Select Customer</h3>
        <Dropdown
          className='dropdown'
          placeholder={'Select Customer'}
          value={selectedCustomer.label ? selectedCustomer : ''}
          onChange={value => {
            setSelectedCustomer({ value, label: value.label });
          }}
          isLoading={loading}
          options={customers}
        />
        <br />
        <input
          type={'file'}
          ref={fileRef}
          style={{ display: 'none' }}
          name={'filePicker'}
          onChange={e => handleSelectedFile(e)}
          accept={'image/jpeg'}
        />
        <FileInputHandler onClick={() => fileRef && fileRef.current?.click()}>
          {imageFile?.name || 'Upload image...'}
          <MdImage size={24} color={'#9297A2'} />
        </FileInputHandler>
        <br />
        <br />
        <PrimaryButton
          text={'Upload'}
          borderRadius={5}
          height={'42px'}
          textColor={'#fff'}
          fontSize={15}
          backgroundColor={'#FF8B22'}
          onClick={() => {
            if (!imageFile) {
              errorToast({ title: 'No Image for Upload' });
              return;
            }

            uploadVirtualBackgroundImage(imageFile)
              .then(result => {
                if (result) {
                  successToast({ title: 'Image uploaded successfully' });
                } else {
                  errorToast({ title: 'Error Occured while upload' });
                }
              })
              .catch(() => {
                errorToast({ title: 'Error Occured while upload' });
              });
          }}
          disabled={loading || !imageSource}
        />
      </Container>
    );
  };
  return (
    <>
      <DocumentHead title='Virtual Background Uploader' />
      <PageTemplate main={getUploaderComponent()} />
    </>
  );
};
